(() => {
  const triggerSelector = '[data-tidio-chat-trigger]';
  const promptSelector = '[data-tidio-chat-prompt]';
  const promptCloseSelector = '[data-tidio-chat-prompt-close]';
  const floatingActionsSelector = '.floating-actions';
  const chatButtonSelector = '[data-tidio-chat-button]';
  const sessionKey = 'muzdan-tidio-prompt-dismissed';
  const revealSessionKey = 'muzdan-tidio-chat-revealed';
  let tidioReady = false;
  let promptTimer;

  const triggers = () => Array.from(document.querySelectorAll(triggerSelector));
  const prompts = () => Array.from(document.querySelectorAll(promptSelector));

  const sessionWasDismissed = () => {
    try {
      return window.sessionStorage.getItem(sessionKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const rememberDismissal = () => {
    try {
      window.sessionStorage.setItem(sessionKey, 'true');
    } catch (error) {
      return;
    }
  };

  const chatWasRevealed = () => {
    try {
      return window.sessionStorage.getItem(revealSessionKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const rememberChatReveal = () => {
    try {
      window.sessionStorage.setItem(revealSessionKey, 'true');
    } catch (error) {
      return;
    }
  };

  const dismissPrompt = (remember = true) => {
    window.clearTimeout(promptTimer);
    if (remember) rememberDismissal();

    prompts().forEach((prompt) => {
      prompt.classList.remove('is-visible');
      window.setTimeout(() => {
        if (!prompt.classList.contains('is-visible')) prompt.hidden = true;
      }, 250);
    });
  };

  const showPrompt = () => {
    if (sessionWasDismissed()) return;

    prompts().forEach((prompt) => {
      prompt.hidden = false;
      window.requestAnimationFrame(() => prompt.classList.add('is-visible'));
    });
  };

  const revealChatControls = () => {
    document.querySelectorAll(floatingActionsSelector).forEach((actions) => {
      actions.classList.add('is-chat-visible');
    });

    document.querySelectorAll(chatButtonSelector).forEach((button) => {
      button.removeAttribute('aria-hidden');
      button.removeAttribute('tabindex');
    });
  };

  const setExpanded = (expanded) => {
    triggers().forEach((trigger) => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const hideNativeLauncher = () => {
    if (!window.tidioChatApi) return;
    window.tidioChatApi.hide();
    setExpanded(false);
  };

  const onReady = () => {
    if (!window.tidioChatApi || tidioReady) return;
    tidioReady = true;
    hideNativeLauncher();
    window.tidioChatApi.on('close', hideNativeLauncher);
  };

  const openChat = () => {
    if (!window.tidioChatApi) return false;
    window.tidioChatApi.show();
    window.tidioChatApi.open();
    setExpanded(true);
    return true;
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest(promptCloseSelector)) {
      event.preventDefault();
      dismissPrompt();
      return;
    }

    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    event.preventDefault();
    dismissPrompt();

    if (!openChat()) {
      document.addEventListener(
        'tidioChat-ready',
        () => {
          onReady();
          openChat();
        },
        { once: true }
      );
    }
  });

  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', onReady);
    onReady();
  } else {
    document.addEventListener('tidioChat-ready', onReady, { once: true });
  }

  document.addEventListener('shopify:section:load', onReady);

  if (chatWasRevealed()) {
    revealChatControls();
  } else {
    promptTimer = window.setTimeout(() => {
      rememberChatReveal();
      revealChatControls();
      showPrompt();
    }, 5000);
  }
})();
